import { selectBanner } from "@/components/homepage/auction/store/slice";
import { getBanner } from "@/components/homepage/auction/store/thunk";
import DataEmpty from "components/common/dataEmpty";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Swiper, SwiperSlide } from "swiper/react";
import styles from "./slider.module.scss";
import { Autoplay, EffectFade, Navigation } from "swiper";
import SlideItem from "./SlideItem";
import "./styles.scss";
import "swiper/css";
import "swiper/css/effect-fade";
import "swiper/css/navigation";

const SliderComponent = () => {
  const dispatch = useDispatch();
  const dataPage = useSelector(selectBanner);

  const [listSliders, setListSliders] = useState<any[]>([]);
  const [paramsGetBanner, setParamsGetBanner] = useState<any>({
    skip: 0,
    limit: 5,
    sort: {
      field: "created_at",
      order: -1,
    },
    filter: [
      {
        name: "status",
        value: "SHOW",
        operator: "eq",
      },
      {
        name: "position",
        value: "HOME",
        operator: "eq",
      },
    ],
  });

  useEffect(() => {
    getListBanner();
  }, [paramsGetBanner]);

  useEffect(() => {
    if (dataPage?.docs?.length > 0) {
      const updatedSliders = dataPage.docs.map((item: any) => ({
        id: item?.id,
        avatar: item?.mediaUrl,
        title: item?.name,
        description: item?.description,
        background: item?.animationUrl ? item?.animationUrl : item?.mediaUrl,
        animationUrl: item?.animationUrl ? item?.animationUrl : null,
        isVideo: item?.animationUrl ? true : false,
      }));

      setListSliders(updatedSliders);
    }
  }, [dataPage]);

  const renderListSlider = () => {
    if (!listSliders?.length) {
      return <DataEmpty />;
    }
    return (
      listSliders?.length > 0 &&
      listSliders?.map((slider) => {
        return (
          <SwiperSlide key={slider?.id}>
            <SlideItem item={slider} />
          </SwiperSlide>
        );
      })
    );
  };

  const getListBanner = async () => {
    dispatch(getBanner(paramsGetBanner));
  };

  return (
    <div className={styles.slider}>
      <Swiper
        className={styles.swiper}
        spaceBetween={20}
        effect={"fade"}
        autoplay={{
          delay: 5000,
          disableOnInteraction: false,
        }}
        loop={true}
        navigation={true}
        modules={[EffectFade, Navigation, Autoplay]}
      >
        {renderListSlider()}
      </Swiper>
    </div>
  );
};

export default SliderComponent;
